// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"7c6106e8","498":"49430727","513":"4acccdf5","787":"3ce4cc4d"}[chunkId] + ".chunk.js";
};